import * as React from 'react';

const LifePreserverFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="life-preserver-fill_svg__eds-icon--life-preserver-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="life-preserver-fill_svg__eds-icon--life-preserver-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M11.9 7.6c.7 0 1.3.2 1.9.4l4.1-4.1C16.3 2.7 14.2 2 12 2s-4.3.7-5.9 1.9l4 4c.6-.2 1.2-.3 1.8-.3zM11.9 16.4c-.7 0-1.3-.1-1.8-.4l-4 4c1.7 1.2 3.7 2 5.9 2s4.3-.7 5.9-2l-4-4c-.6.3-1.3.4-2 .4zM7.5 12c0-.7.2-1.4.5-2L4 6c-1.3 1.7-2 3.8-2 6s.7 4.3 1.9 5.9l4-4c-.3-.6-.4-1.2-.4-1.9zM20 6.1l-4.1 4.1c.3.6.4 1.2.4 1.8 0 .6-.1 1.3-.4 1.8l4.1 4.1c1.2-1.7 1.9-3.7 1.9-5.9.1-2.2-.6-4.3-1.9-5.9z" />
        </g>
        <g
            id="life-preserver-fill_svg__eds-icon--life-preserver-fill_lines"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path
                transform="rotate(-134.999 7.182 16.702)"
                d="M6.7 12.7h1v8h-1z"
            />
            <path
                transform="rotate(-134.999 7.202 7.182)"
                d="M3.2 6.7h8v1h-8z"
            />
            <path transform="rotate(45.001 16.72 7.2)" d="M16.2 3.2h1v8h-1z" />
            <path
                transform="rotate(-134.999 16.701 16.721)"
                d="M12.7 16.2h8v1h-8z"
            />
        </g>
    </svg>
);

LifePreserverFillSvg.displayName = 'LifePreserverFillSvg';
export default LifePreserverFillSvg;
